import { onlyText } from '@shieldpay/utilities-ui/only-text';

import type { DecoratedToastContent, ToastContent } from './types';

export const isDecoratedToastContent = (
  toastContent: ToastContent,
): toastContent is DecoratedToastContent =>
  Object.prototype.hasOwnProperty.call(toastContent, 'icon');

/**
 * Accepts a toast notification and calculates the character length
 */
export const getDismissalTimeFromCharacterLength = (
  toastContent: ToastContent,
  characterTimeMultiplier: number,
): number => {
  const text = isDecoratedToastContent(toastContent)
    ? onlyText(toastContent.text)
    : onlyText(toastContent);
  return text.length * characterTimeMultiplier;
};
